import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "babel-runtime/helpers/possibleConstructorReturn";
import _inherits from "babel-runtime/helpers/inherits";
import React, { PureComponent } from "react";
import Lion from "@rosetta/react-lion";
import styled from "@emotion/styled";

import PropTypes from "prop-types";
import { SREIcon } from "./SREIcon";

var styleVariables = {
  grey: "#A4ABAE", // darker grey seen in most of the 'grey' icons
  buttonBorderColor: "#999999",
  darkBlue: "#0B3464",
  white: "#ffffff",
  black: "#000000",
  primary: "#34A3E7" // Picton Blue (blue)
};

var VoiceTypeSelectionButton = styled.div(function (props) {
  var styles = [{
    height: 135,
    width: 135,
    padding: 10,
    margin: 10,
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    border: "1px solid",
    borderRadius: 3,
    boxSizing: "border-box",

    textAlign: "center",
    fontSize: 16,
    fontWeight: "bold",
    "& div + div ": {
      paddingTop: 10
    }
  }];

  if (props.selected) {
    if (props.disabled) {
      styles.push({
        backgroundColor: styleVariables.grey,
        borderColor: styleVariables.buttonBorderColor,
        color: styleVariables.white,
        cursor: "not-allowed"
      });
    } else {
      styles.push({
        backgroundColor: styleVariables.darkBlue,
        borderColor: styleVariables.buttonBorderColor,
        color: styleVariables.white,
        cursor: "pointer"
      });
    }
  } else {
    if (props.disabled) {
      styles.push({
        backgroundColor: styleVariables.white,
        borderColor: styleVariables.buttonBorderColor,
        color: styleVariables.grey,
        cursor: "not-allowed"
      });
    } else {
      styles.push({
        backgroundColor: styleVariables.white,
        borderColor: styleVariables.buttonBorderColor,
        color: styleVariables.black,
        "&:hover": {
          borderColor: styleVariables.primary,
          borderWidth: 3,
          padding: 8
        }
      });
    }
  }
  return styles;
});

var VoiceTypeIconDiv = styled.div({});
var VoiceTypeLabelDiv = styled(Lion.div)({});

export var voiceTypes = {
  male: "male",
  female: "female",
  child: "child"
};

export var iconStates = {
  selected: "selected",
  active: "active",
  disabled: "disabled"
};

var VoiceTypeButton = function (_PureComponent) {
  _inherits(VoiceTypeButton, _PureComponent);

  function VoiceTypeButton() {
    var _temp, _this, _ret;

    _classCallCheck(this, VoiceTypeButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.renderIcon = function (voiceType, iconState) {
      if (iconState === iconStates.selected) {
        switch (voiceType) {
          case voiceTypes.female:
            return React.createElement(SREIcon, { buttonState: iconState, ico: "VoiceTypeFemaleActiveIcon" });
          case voiceTypes.child:
            return React.createElement(SREIcon, { buttonState: iconState, ico: "VoiceTypeChildActiveIcon" });
          default:
            return React.createElement(SREIcon, { buttonState: iconState, ico: "VoiceTypeMaleActiveIcon" });
        }
      } else {
        switch (voiceType) {
          case voiceTypes.female:
            return React.createElement(SREIcon, { buttonState: iconState, ico: "VoiceTypeFemaleInactiveIcon" });
          case voiceTypes.child:
            return React.createElement(SREIcon, { buttonState: iconState, ico: "VoiceTypeChildInactiveIcon" });
          default:
            return React.createElement(SREIcon, { buttonState: iconState, ico: "VoiceTypeMaleInactiveIcon" });
        }
      }
    }, _this.render = function () {
      var clickAction = _this.props.clickVoiceType;
      if (_this.props.disabled || _this.props.selected) {
        clickAction = function clickAction() {};
      }

      return React.createElement(
        "div",
        { "data-value": _this.props.value, id: _this.props.id, onClick: clickAction },
        React.createElement(
          VoiceTypeSelectionButton,
          { selected: _this.props.selected, disabled: _this.props.disabled },
          React.createElement(
            VoiceTypeIconDiv,
            null,
            _this.renderIcon(_this.props.value, _this.props.selected, _this.props.disabled)
          ),
          React.createElement(VoiceTypeLabelDiv, { lionkey: _this.props.labelKey })
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return VoiceTypeButton;
}(PureComponent);

VoiceTypeButton.propTypes = {
  labelKey: PropTypes.string,
  value: PropTypes.string,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  clickVoiceType: PropTypes.func
};

export default VoiceTypeButton;